<script setup lang="ts">
    import ChevronLeftIcon from '@/components/icons/ChevronLeftIcon.vue';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    defineProps<{
        onClick:() => void
        text?: string
        hideText?: boolean
    }>();
</script>

<template>
    <a
        class="link-btn link-btn-with-icon"
        @click="() => onClick()"
    >
        <ChevronLeftIcon />
        <template v-if="!hideText">
            {{ text ?? t('widget.navigation.back') }}
        </template>

    </a>
</template>

<style scoped lang="scss">
// eslint-disable-next-line vue-scoped-css/require-selector-used-inside
.link-btn-with-icon {
    display: inline-flex;
    align-items: center;
    font-size: var(--font-regular);
    font-weight: 500;
    padding-inline-end: 10px;
    text-decoration: underline;

    // eslint-disable-next-line vue-scoped-css/no-unused-selector
    svg {
        margin-block-start: 1px;
    }
}
</style>
